export default __webpack_public_path__ + "5f2fd49d92f6865cd9644b9dbd7e968e.png";